var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table offer-info" },
    [
      _vm._l(_vm.rounds, function (round) {
        return round.ssrRoundSupplierPqcps.length > 0 ||
          round.ssrRoundSupplierPcns.length > 0
          ? _c(
              "div",
              [
                _c(
                  "div",
                  [
                    _vm._v("Round " + _vm._s(round.roundNumber) + " "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.offerDownload(round.ttSsrRoundId)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("ssrManage.offerDownload")))]
                    ),
                  ],
                  1
                ),
                round.ssrRoundSupplierPqcps != null &&
                round.ssrRoundSupplierPqcps.length > 0
                  ? _c("pqcp-table", {
                      attrs: {
                        data: round.ssrRoundSupplierPqcps,
                        "can-edit": _vm.canEdit,
                        "can-edit-freight-forcast": _vm.canEditFreightForcast,
                      },
                    })
                  : _vm._e(),
                round.ssrRoundSupplierPcns != null &&
                round.ssrRoundSupplierPcns.length > 0
                  ? _c("pcn-table", {
                      attrs: {
                        data: round.ssrRoundSupplierPcns,
                        "can-edit": _vm.canEdit,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e()
      }),
      _c(
        "el-row",
        {
          staticStyle: { "padding-top": "15px" },
          attrs: { type: "flex", justify: "center" },
        },
        [
          _vm.canEditFreightForcast
            ? _c(
                "el-button",
                {
                  key: "save",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveLogisticInfo()
                    },
                  },
                },
                [_vm._v("Save As Draft")]
              )
            : _vm._e(),
          _vm.roundIds.length > 1
            ? _c(
                "el-button",
                {
                  key: "downloadAll",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.offerDownload(_vm.roundIds)
                    },
                  },
                },
                [_vm._v("Download All")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }